<template>
  <div class="main relatorios">
    <c-panel title="Relatórios Financeiros" titleIcon="far fa-chart-bar">
      <el-form label-position="top">
        <el-row :gutter="10" class="u-mt-10">
          <el-col :xs="24" :sm="18" :md="18">
            <el-form-item label="Instituição" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
              <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
              <label class="el-form-item__label">Instituição</label>
              <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Ano" key="ano">
              <el-input v-model="filtro.ano" maxlength="4" placeholder="ex: 2026"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Relatório" key="relatorio">
              <el-select v-model="relatorioSelected" placeholder="Selecione" filterable>
                <el-option label="EXECUÇÃO DO PDDE" value="execucao"></el-option>
                <el-option label="GASTOS POR CATEGORIA" value="categoria"></el-option>
                <el-option label="SALDO DO RECURSO" value="saldo"></el-option>
                <el-option label="HISTÓRICO DE COMPRAS" value="historico"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Programa" key="programa_id">
              <el-select v-model="filtro.programa_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getProgramaByFilter" :loading="loadingPrograma">
                <el-option v-for="item in programas" :key="item.id" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Recurso" key="recurso_id">
              <el-select v-model="filtro.recurso_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getRecursoByFilter" :loading="loadingRecurso">
                <el-option v-for="item in recursos" :key="item.id" :label="recursoLabel(item)" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Data inicial" key="data_inicio">
              <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Data final" key="data_fim">
              <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" class="u-text-right u-mt-20">
            <el-button @click="emitPdf()" :loading="loadingButtonPdf" type="primary">PDF</el-button>
            <el-button @click="emitHtml()" :loading="loadingButtonHtml" type="primary">HTML</el-button>
          </el-col>
        </el-row>
      </el-form>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
  }
  ,
  data: () => ({
    relatorioSelected: 'execucao',
    loadingButtonPdf: false,
    loadingButtonHtml: false,
    loadingPrograma: false,
    programas: [],
    loadingRecurso: false,
    recursos: [],
    ref: [],
    filtro: {
      instituicao_id: '',
      ano: '',
      programa_id: '',
      recurso_id: '',
      data_inicio: '',
      data_fim: ''
    }
  }),
  mounted () {
    if (this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9) {
      this.filtro.instituicao_id = this.$store.state.config.instituicao.id
    }
    this.filtro.ano = String((new Date()).getFullYear())
  },
  methods: {
    getProgramaByFilter (query) {
      if (!query || query.length < 2) {
        this.programas = []
        return false
      }
      this.loadingPrograma = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/programa/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.programas = JSON.parse(JSON.stringify(response.data))
        this.loadingPrograma = false
      }).catch((error) => { this.loadingPrograma = false; this.$store.commit('throwException', error) })
    },
    getRecursoByFilter (query) {
      if (!query || query.length < 2) {
        this.recursos = []
        return false
      }
      this.loadingRecurso = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/recurso/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.recursos = JSON.parse(JSON.stringify(response.data))
        this.loadingRecurso = false
      }).catch((error) => { this.loadingRecurso = false; this.$store.commit('throwException', error) })
    },
    recursoLabel (item) {
      const programa = item.programa ? item.programa.nome : ('#' + item.programa_id)
      return `${programa} - ${item.ano} - ${this.formatMoney(item.valor_total)}`
    },
    buildRef () {
      const ref = []
      if (this.filtro.instituicao_id) {
        let nome = 'Instituição'
        let valor = this.filtro.instituicao_id
        if (this.$refs.instituicao_id && this.$refs.instituicao_id.selected && this.$refs.instituicao_id.selected.label) {
          valor = this.$refs.instituicao_id.selected.label
        } else if (this.$store.state.config.instituicao && this.$store.state.config.instituicao.nome) {
          valor = this.$store.state.config.instituicao.nome
        }
        ref.push({ nome, valor })
      }
      if (this.filtro.ano) ref.push({ nome: 'Ano', valor: this.filtro.ano })
      if (this.filtro.programa_id) {
        const p = this.programas.find(x => x.id === this.filtro.programa_id)
        ref.push({ nome: 'Programa', valor: p ? p.nome : this.filtro.programa_id })
      }
      if (this.filtro.recurso_id) ref.push({ nome: 'Recurso', valor: this.filtro.recurso_id })
      if (this.filtro.data_inicio) ref.push({ nome: 'Data inicial', valor: this.filtro.data_inicio })
      if (this.filtro.data_fim) ref.push({ nome: 'Data final', valor: this.filtro.data_fim })
      this.ref = ref
    },
    getPdfUrl () {
      if (this.relatorioSelected === 'execucao') return '/api/pdf/renderRelatorioFinanceiroExecucaoPdde/pdf'
      if (this.relatorioSelected === 'categoria') return '/api/pdf/renderRelatorioFinanceiroGastosPorCategoria/pdf'
      if (this.relatorioSelected === 'saldo') return '/api/pdf/renderRelatorioFinanceiroSaldoRecurso/pdf'
      return '/api/pdf/renderRelatorioFinanceiroHistoricoCompras/pdf'
    },
    getHtmlSlug () {
      if (this.relatorioSelected === 'execucao') return 'financeiro-execucao-pdde'
      if (this.relatorioSelected === 'categoria') return 'financeiro-gastos-por-categoria'
      if (this.relatorioSelected === 'saldo') return 'financeiro-saldo-recurso'
      return 'financeiro-historico-compras'
    },
    validateFiltro () {
      if (!this.filtro.instituicao_id) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição.', type: 'warning' })
        return false
      }
      return true
    },
    emitPdf () {
      if (!this.validateFiltro()) return
      this.buildRef()
      this.loadingButtonPdf = true
      window.eventBus.$emit('print', { url: this.getPdfUrl(), param: { ref: this.ref, filtros: this.filtro } })
      this.loadingButtonPdf = false
    },
    async emitHtml () {
      if (!this.validateFiltro()) return
      this.buildRef()
      this.loadingButtonHtml = true
      try {
        const slug = this.getHtmlSlug()
        const response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/` + slug, { ref: this.ref, filtros: this.filtro }, this.$store.getters.getHeaderAuth)
        window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`)
      } catch (e) {
        window.eventBus.$emit('alert', { msg: 'Erro ao gerar relatório.', type: 'warning' })
      }
      this.loadingButtonHtml = false
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

